module.exports = __webpack_public_path__ + "img/bd_other02.69c661f5.png";